module.exports = __webpack_public_path__ + "static/media/help.67594e97.png";